import React from 'react';
import { GiftIcon } from 'lucide-react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-18" data-mp="pio8yn0kl492">
      <div className="mx-auto max-w-5xl" data-id="element-19" data-mp="avcvugoqpc6u">
        <div className="mx-auto max-w-2xl text-center" data-id="element-20" data-mp="aua4k7ni97qe">
          <span className="inline-flex items-center gap-2 rounded-full bg-tangerine-light px-4 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.18em] text-tangerine-dark" data-id="element-21" data-mp="ftwmguea3c5j">
            <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-22" data-mp="1wrg0tankb9r" />
            Solo per oggi
          </span>
          <h2 className="mt-5 font-display text-[1.9rem] font-black leading-tight tracking-tight text-navy sm:text-[2.6rem]" data-id="element-23" data-mp="3o1lgyw505tlk">
            5 Bonus <span className="italic text-grape" data-id="element-24" data-mp="3t1r8mcb9vg3n">Strategici</span> in
            regalo
          </h2>
          <p className="mx-auto mt-4 max-w-lg text-sm leading-relaxed text-navy/60" data-id="element-25" data-mp="1mb9zlb18m0o4">
            Cinque kit extra pensati per la classe di musica, inclusi nel tuo
            ordine di oggi senza costi aggiuntivi.
          </p>
        </div>

        <ol className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-26" data-mp="3icbxe464obs4">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex h-full flex-col overflow-hidden rounded-3xl bg-white shadow-[0_18px_40px_-28px_rgba(22,56,111,0.5)]" data-id="element-27" data-mp="3r6qgyixoy8h1" data-mpi={index}>
              <div className="relative bg-white px-6 pb-6 pt-10" data-id="element-28" data-mp="2zfkfnz68i4q6">
                <span className="absolute left-5 top-5 flex h-9 w-9 items-center justify-center rounded-full bg-navy font-display text-sm font-bold text-white" data-id="element-29" data-mp="2zfu77r6xgjxz">
                  {index + 1}
                </span>
                <span className="absolute right-5 top-5 rounded-full bg-tangerine px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.12em] text-white" data-id="element-30" data-mp="38e5upkchz1m7">
                  Bonus
                </span>
                <img src={bonus.cover} alt={`Copertina del bonus ${bonus.title}`} className="mx-auto h-72 w-auto object-contain mix-blend-multiply sm:h-80" data-id="element-31" data-mp="nrulcofr8556" />
              </div>

              <div className="flex flex-1 flex-col px-6 pb-7 pt-6" data-id="element-32" data-mp="3hgya9amfxium">
                <h3 className="font-display text-base font-bold leading-snug text-navy" data-id="element-33" data-mp="3ljuluhdkcep2">
                  {bonus.title}
                </h3>
                <p className="mt-2 flex-1 text-xs leading-relaxed text-navy/60" data-id="element-34" data-mp="3qhedciz9unyy">
                  {bonus.text}
                </p>
                <p className="mt-5 border-t border-navy/10 pt-4 text-[11px] font-bold uppercase tracking-[0.12em] text-teal" data-id="element-35" data-mp="2tqc4xr3tmcob">
                  Incluso gratis
                </p>
              </div>
            </li>)}

          <li className="flex h-full flex-col items-center justify-center rounded-3xl border-2 border-dashed border-navy/20 bg-cream px-6 py-10 text-center" data-id="element-36" data-mp="37jjw5hnzp65h">
            <span className="font-display text-4xl font-black text-navy" data-id="element-37" data-mp="2a4601tc1plpu">5</span>
            <p className="mt-2 text-[11px] font-bold uppercase tracking-[0.16em] text-navy/45" data-id="element-38" data-mp="2f27q4y7w2lat">
              bonus inclusi
            </p>
            <p className="mt-4 max-w-[15rem] text-xs leading-relaxed text-navy/60" data-id="element-39" data-mp="22kx0ssx973ei">
              Tutti e 5 i kit arrivano insieme ai volumi, nella stessa email,
              subito dopo l&apos;acquisto.
            </p>
            <span className="mt-5 rounded-full bg-teal px-4 py-2 text-[11px] font-extrabold uppercase tracking-[0.12em] text-white" data-id="element-40" data-mp="1tkrruecevwy8">
              Già inclusi
            </span>
          </li>
        </ol>
      </div>
    </section>;
}